import { UserProfile } from "@api/models/UserProfile";
import { QueryParametersInterface } from "@api/repositories/interfaces/QueryParametersInterface";
import { UserRepository } from "@api/repositories/UserRepository";
import { getUserInfoForSelectTitle } from "@share/common/helpers/userProfileNameHelper";
import { SelectSourceParams, SelectSourceServiceInterface } from "@share/common/types/interfaces/select-control/SelectSourceServiceInterface";
import Axios, { CancelTokenSource } from "axios";

export class SelectUsersSourceService implements SelectSourceServiceInterface {

    private cancelToken: CancelTokenSource | null = null;

    constructor(
        private userRepository: UserRepository,
        private include: string[]
    ) {

    }

    async getSelectSource(params: SelectSourceParams) {
        return (await this.loadData(params)).map(item => {
            return Object.freeze({
                id: item.userId?.toString() || "",
                title: getUserInfoForSelectTitle(item, "direction")
            })
        });
    }

    private loadData({ keyword, searchableFields = ['firstName', 'lastName'], keywordLength = 3 }: SelectSourceParams): Promise<UserProfile[]> {
        if (keyword.length < keywordLength) {
            return new Promise((resolve) => { resolve([]) });
        }

        if (this.cancelToken) {
            this.cancelToken.cancel();
        }

        const parts: string[] = keyword.split(' ');
        const words: string[] = parts.map((part: string) => `(?i).*${part}.*`);

        let query: QueryParametersInterface = {
            take: 30,
            include: this.include,
            order: {
                firstName: 'asc'
            },
            where: {
                $search: [
                    searchableFields,
                    words
                ]
            }
        };

        this.cancelToken = Axios.CancelToken.source();

        return this.userRepository.profiles(query, {
            cancelToken: this.cancelToken.token
        });
    }
}